import axios from "axios";

export const BASE_URL = process.env.REACT_APP_HOST_API;
export const BASE_URL_ERP = process.env.REACT_APP_API_ERP;

export const AXIOS = axios.create({ baseURL: BASE_URL + "api/" });

export const AXIOS_ERP = axios.create({
  baseURL: BASE_URL_ERP + "api/",
});
